import { BrandBgEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgSetEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgSetEventVO.validationSchema(),
    BrandBgEntity
  );

  constructor(readonly value: RoomBrandBgSetEvent) {
    JsonSchemaValidator.assert(RoomBrandBgSetEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandBg"],
      properties: {
        roomId,
        brandBg: {
          instanceof: BrandBgEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgSetEvent {
  roomId: RoomId;
  brandBg: BrandBgEntity;
}
